export enum MapPane {
  Map = 'map',
  Resource = 'resource',
  Poi = 'poi',
  Path = 'path',
  Portal = 'portal',
  ControlMonitor = 'control-monitor',
}

export const MAP_PANE_ORDER: Record<MapPane, number> = {
  [MapPane.Map]: 0,
  [MapPane.Resource]: 1,
  [MapPane.Poi]: 2,
  [MapPane.Path]: 3,
  [MapPane.Portal]: 4,
  [MapPane.ControlMonitor]: 5,
};

export const MAP_PANE_Z_INDEX_STRIDE = 100_000;
export const MAP_ACTIVE_Z_INDEX_OFFSET = 10_000;
